module.exports = __webpack_public_path__ + "static/media/img_imsg_text_field.125c24f7.png";